import {
  loginMockHandler,
  logoutMockHandler,
  registerMockHandler,
  registrationDetailsMockHandler,
  resendOtpMockHandler,
  resetPasswordMockHandler,
  sendOtpMockHandler,
  submitOtpMockHandler,
} from '@/features/auth/api';

export const authHandlers = [
  loginMockHandler,
  logoutMockHandler,
  registerMockHandler,
  registrationDetailsMockHandler,
  resendOtpMockHandler,
  resetPasswordMockHandler,
  sendOtpMockHandler,
  submitOtpMockHandler,
];
